export const SIX_PILLARS_ACCORDION_ID = "SixPillarsAccordionId";
export const SIX_PILLARS_STYLED_ACCORDION_ID = "SixPillarsStyledAccordionId";
export const SIX_PILLARS_SUMMARY = "SixPillarsSummary";
export const SIX_PILLARS_DETAILS = "SixPillarsDetails";
